import { useMemo } from "react";

import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";

import { ListResearchReport } from "core/http/service/researchReport/resTypes";
import pathRoutes from "routes/pathRoutes";

import { ReactComponent as Background } from "assets/background/research-report-item-bg.svg";
import { ReactComponent as IconArrowHeadDown } from "assets/svg/20-arrowhead-down.svg";
import { ReactComponent as IconOpenInNew } from "assets/svg/20-open-in-new.svg";

import {
  Action,
  BackgroundItemWrap,
  BottomBox,
  BoxIcon,
  Content,
  CreateDay,
  ReportBox,
  TitleReport,
} from "../styles";
import { motion } from "framer-motion";
import { ReduxStateType } from "redux-store/types";
import { SxProps } from "@mui/material";
import { decodeHtml } from "helper/utils";

const Report = ({
  reportContent,
  index,
  rowOfTitle,
  sxProps,
}: {
  reportContent: ListResearchReport;
  index: number;
  status: ReduxStateType;
  rowOfTitle?: number;
  sxProps?: SxProps;
}) => {
  const { tab } = useParams();
  const navigate = useNavigate();

  const { createdDate, nodeId, text } = reportContent;

  const itemLink = useMemo(() => {
    const pathname = pathRoutes.researchReport.detail.parameter.replace(
      ":tab",
      tab
    );
    return pathname.replace(":id", nodeId.toString());
  }, [nodeId, tab]);

  return (
    <motion.div
      initial={index < 12 ? { opacity: 0, scale: 0.3 } : {}}
      animate={index < 12 ? { opacity: 1, scale: 1 } : {}}
      transition={{ delay: index < 12 ? index * 0.05 : 0 }}
    >
      <ReportBox
        onClick={() => navigate(itemLink, { replace: true })}
        sx={sxProps}
      >
        <BoxIcon>
          <IconArrowHeadDown />
        </BoxIcon>
        <Content>
          <TitleReport rowOfTitle={rowOfTitle}>{decodeHtml(text)}</TitleReport>
          <BottomBox>
            <CreateDay>
              Ngày đăng: {moment(createdDate).format("DD/MM/YYYY")}
            </CreateDay>
            <Action>
              <IconOpenInNew />
            </Action>
          </BottomBox>
        </Content>
        <BackgroundItemWrap>
          <Background />
        </BackgroundItemWrap>
      </ReportBox>
    </motion.div>
  );
};

export default Report;
